/**
 * Route for `payment-provider-integration-for-influencer-payouts`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PaymentProviderIntegrationForInfluencerPayoutsPage } from "../features/payment-provider-integration-for-influencer-payouts/PaymentProviderIntegrationForInfluencerPayoutsPage";

export const paymentProviderIntegrationForInfluencerPayoutsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/payment-provider-integration-for-influencer-payouts",
	component: PaymentProviderIntegrationForInfluencerPayoutsPage,
});

export default paymentProviderIntegrationForInfluencerPayoutsRoute;
